"use client";

import { Suspense, useEffect, useState } from "react";
import { withErrorBoundary } from "@sentry/nextjs";
import { PropertyTypeV2 } from "commonModule/services/common";
import PrequoteErrorModal from "components/modals/PrequoteErrorModel";
import { useIsAgent } from "hooks/useIsAgent";
import { useIsTravelAgentClient } from "hooks/useIsTravelAgentClient";
import { markBookingStore, selectBookingCalendarRateList, selectBookingStore } from "stores/booking/bookingSlice";
import { useAppDispatch, useAppSelector } from "stores/hooks";
import { useMediaQuery } from "utils/hooks/useMediaQuery";
import BookingCardDesktop from "./booking-section/BookingCardDesktop";
import { BookingPriceLoading } from "./booking-section/BookingPriceLoading";
import BookingStickyMobile from "./booking-section/BookingStickyMobile";
const BookingWrapper = ({
  property,
  className
}: {
  property: PropertyTypeV2;
  className?: string;
}) => {
  const [isStickyToBottom] = useMediaQuery("(max-width: 991px)");
  const [isMounted, setIsMounted] = useState(false);
  const dispatch = useAppDispatch();
  const calendarRateList = useAppSelector(selectBookingCalendarRateList);
  const bookingStore = useAppSelector(selectBookingStore);
  const isAgent = useIsAgent();
  const isTravelAgentClient = useIsTravelAgentClient();
  const isCalendarRatesAvailable = calendarRateList && calendarRateList.length > 0;
  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Only wait for calendar rates if the user can actually see pricing
  const needsCalendarRates = isAgent || isTravelAgentClient;
  const shouldShowBookingContent = isMounted && (!needsCalendarRates || isCalendarRatesAvailable);
  return <>
      <div className={className ?? "w-full shrink-0 lg:w-[392px]"}>
        <Suspense fallback={<BookingPriceLoading className='shadow-[0_4px_20px_0_rgba(55,56,77,0.13)]' />} data-sentry-element="Suspense" data-sentry-source-file="BookingWrapper.tsx">
          {shouldShowBookingContent ? isStickyToBottom ? <BookingStickyMobile property={property} /> : <BookingCardDesktop property={property} /> : <BookingPriceLoading className='shadow-[0_4px_20px_0_rgba(55,56,77,0.13)]' />}
        </Suspense>
      </div>
      <PrequoteErrorModal isOpen={!!bookingStore.error} onClose={() => {
      dispatch(markBookingStore({
        error: "",
        status: null
      }));
    }} data-sentry-element="PrequoteErrorModal" data-sentry-source-file="BookingWrapper.tsx" />
    </>;
};
export default withErrorBoundary(BookingWrapper, {
  beforeCapture: scope => {
    scope.setTag("ws_location", "BookingWrapper");
  }
});